import React, { Component } from "react";
import CommToolContext from "../common/comm_tool_context";
import 'antd/dist/antd.css';
import Layout from "components/Layout";
import {withRouter} from "react-router-dom";

class StartProjectConsumer extends Component {
  render() {
    return (
        <CommToolContext.Consumer>
          {context => (
              <React.Fragment>
                {context.state.launchDashboard && <Layout />}
              </React.Fragment>
          )}
        </CommToolContext.Consumer>
    );
  }
}

class StartProject extends Component {
  render() {
    return (
        <StartProjectConsumer />
    );
  }
}

StartProject.contextType = CommToolContext;
export default withRouter(StartProject);
